import { CollapsibleElement } from '../shared/collapsibleElement/CollapsibleElement';
import { SectionElement } from '../shared/sectionElement/SectionElement';
import { Description } from './Description';
import { PreferenceFields } from './PreferenceFields';
import type { PreferencesElementProps } from './PreferencesElement.types';

export function PreferencesElement(props: PreferencesElementProps) {
  const {
    isLive,
    translations,
    element,
    onSubscriptionPreferenceChange,
    onTrueFalsePreferenceChange,
    onShortResponsePreferenceChange,
    onDropdownPreferenceChange,
    onMultipleChoicePreferenceChange,
    onSingleChoicePreferenceChange,
  } = props;

  const { preferences, email } = element.attrs?.data || {};

  const description = (
    <>
      <Description
        email={email}
        descriptionText={translations?.['manage.preferences.description'] || 'Manage your preferences for'}
      />
      {translations?.['manage.preferences.note'] && (
        <p className="text-xs text-gray-500">{translations['manage.preferences.note']}</p>
      )}
    </>
  );

  return (
    <SectionElement
      title={translations?.['manage.preferences.title'] || 'Subscription preferences'}
      subTitle={description}
    >
      <CollapsibleElement
        showButtonLabel={translations?.['manage.preferences.show']}
        hideButtonLabel={translations?.['manage.preferences.hide']}
        defaultOpen={true}
      >
        <PreferenceFields
          preferences={preferences}
          isLive={isLive}
          onDropdownPreferenceChange={onDropdownPreferenceChange}
          onShortResponsePreferenceChange={onShortResponsePreferenceChange}
          onSingleChoicePreferenceChange={onSingleChoicePreferenceChange}
          onMultipleChoicePreferenceChange={onMultipleChoicePreferenceChange}
          onTrueFalsePreferenceChange={onTrueFalsePreferenceChange}
          onSubscriptionPreferenceChange={onSubscriptionPreferenceChange}
          translations={translations}
        />
      </CollapsibleElement>
    </SectionElement>
  );
}
